import { render } from "./AddWebhookModal.vue?vue&type=template&id=54c85acb&scoped=true"
import script from "./AddWebhookModal.vue?vue&type=script&lang=js"
export * from "./AddWebhookModal.vue?vue&type=script&lang=js"

import "./AddWebhookModal.vue?vue&type=style&index=0&id=54c85acb&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54c85acb"]])

export default __exports__